var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-back-button"},[_c('img',{attrs:{"src":"/images/game/back.png"},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }